
export enum ChatInfoType {
  NONE,
  PEERS,
  IMAGES,
  VIDEOS,
  FILES,
  VOICES,
  AUDIOS,
  LINKS,
  GIFS,
  STICKERS,
  MEMBERS,
}

export default ChatInfoType;
